var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification4Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_12417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_12417)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2291 13.1046C11.2289 12.1044 10.667 10.7478 10.667 9.33333C10.667 7.91885 11.2289 6.56229 12.2291 5.5621C13.2293 4.5619 14.5858 4 16.0003 4C17.4148 4 18.7714 4.5619 19.7716 5.5621C20.7718 6.56229 21.3337 7.91885 21.3337 9.33333C21.3337 10.7478 20.7718 12.1044 19.7716 13.1046C18.7714 14.1048 17.4148 14.6667 16.0003 14.6667C14.5858 14.6667 13.2293 14.1048 12.2291 13.1046ZM8 22.3333V28H24L24 22.3333C24 20.9188 23.4381 19.5623 22.4379 18.5621C21.4377 17.5619 20.0812 17 18.6667 17H13.3333C11.9188 17 10.5623 17.5619 9.5621 18.5621C8.5619 19.5623 8 20.9188 8 22.3333Z",
    fill: "#00A266"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification4Icon);
export default __webpack_public_path__ + "static/media/notification4-icon.5b6f45817d1904a65eff18f453ddc9f5.svg";
export { ForwardRef as ReactComponent };